import type { Address } from '@/models/Address.ts'
import type { Patch } from '@/models/normalize.ts'
import type { DeviceDTO, OpenApiDeviceStatus } from '@/models/openapi.ts'
import type { ServiceUser } from '@/models/ServiceUser.ts'

import type { DeviceControlCommand } from './DeviceControl'

export const DEVICE_STATUSES = [
  'ACTIVE',
  'INACTIVE',
  'MAINTENANCE',
] as const satisfies readonly OpenApiDeviceStatus[]

export type DeviceStatus = (typeof DEVICE_STATUSES)[number]

export type IotcommsDevice = {
  authType: string
  deviceId: string
  password: string
  deviceType: string
  description?: string | null
}

/** Backend returns parsed JSON for `address`, `iotcommsDevice`, `info`, `commands`. */
export type Device = Patch<
  DeviceDTO,
  {
    address?: Address
    iotcommsDevice?: IotcommsDevice
    boundServiceUsers?: ServiceUser[]
    info?: {
      provider?: string | null
      product?: string | null
      protocol?: string | null
    }
    commands?: { canonical: DeviceControlCommand }[]
    integrationData?: { iotcomms_device: IotcommsDevice }
  }
>

export function getIotcommsDeviceInfo(device?: Device | null): IotcommsDevice | null {
  if (!device) {
    return null
  }
  return device?.integrationData?.iotcomms_device ?? device.iotcommsDevice ?? null
}
